export default __webpack_public_path__ + "static/media/xls.ebead78d.svg";